import React, { useState } from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ProjectCard = ({ project, onViewDetails, onShare }) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleShare = (e) => {
    e?.stopPropagation();
    onShare(project);
  };

  return (
    <div 
      className="group bg-card rounded-2xl overflow-hidden shadow-lg hover:shadow-premium-lg transition-all duration-500 cursor-pointer"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={() => onViewDetails(project)}
    >
      {/* Project Image */}
      <div className="relative h-64 overflow-hidden">
        <Image
          src={project?.mainImage}
          alt={project?.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
        />
        
        {/* Máscara preta com transparência uniforme */}
        <div className="absolute inset-0 bg-black/30"></div>
        
        {/* Overlay with project info */}
        <div className={`absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent transition-opacity duration-300 ${
          isHovered ? 'opacity-100' : 'opacity-0'
        }`}>
          <div className="absolute bottom-4 left-4 right-4">
            <div className="flex items-center justify-between text-white">
              <div className="flex items-center space-x-2">
                <Icon name="MapPin" size={16} color="white" />
                <span className="text-sm font-medium">{project?.location}</span>
              </div>
              <button
                onClick={handleShare}
                className="p-2 bg-white/20 backdrop-blur-sm rounded-full hover:bg-white/30 transition-colors duration-200"
              >
                <Icon name="Share2" size={16} color="white" />
              </button>
            </div>
          </div>
        </div>

        {/* Project Category Badge */}
        <div className="absolute top-4 left-4">
          <span className="px-3 py-1 bg-primary text-primary-foreground text-xs font-semibold rounded-full">
            {project?.category}
          </span>
        </div>

        {/* Budget Range Badge */}
        <div className="absolute top-4 right-4">
          <span className="px-3 py-1 bg-accent text-accent-foreground text-xs font-semibold rounded-full">
            {project?.budgetRange}
          </span>
        </div>
      </div>
      {/* Project Details */}
      <div className="p-6">
        <div className="flex items-start justify-between mb-3">
          <h3 className="font-playfair font-bold text-xl text-text-primary group-hover:text-primary transition-colors duration-300">
            {project?.title}
          </h3>
          <div className="flex items-center space-x-1 text-accent">
            {[...Array(5)]?.map((_, i) => (
              <Icon
                key={i}
                name="Star"
                size={14}
                color={i < project?.rating ? "var(--color-accent)" : "var(--color-border)"}
                strokeWidth={0}
                className="fill-current"
              />
            ))}
          </div>
        </div>

        <p className="text-text-secondary text-sm mb-4 line-clamp-2">
          {project?.description}
        </p>

        {/* Project Stats */}
        <div className="flex items-center justify-between text-sm text-text-secondary mb-4">
          <div className="flex items-center space-x-1">
            <Icon name="Calendar" size={14} />
            <span>{project?.completionDate}</span>
          </div>
          <div className="flex items-center space-x-1">
            <Icon name="Clock" size={14} />
            <span>{project?.duration}</span>
          </div>
          <div className="flex items-center space-x-1">
            <Icon name="Package" size={14} />
            <span>{project?.pieceCount} peças</span>
          </div>
        </div>

        {/* Client Info */}
        <div className="flex items-center space-x-3 mb-4">
          <Image
            src={project?.client?.avatar}
            alt={project?.client?.name}
            className="w-8 h-8 rounded-full object-cover"
          />
          <div>
            <p className="font-medium text-text-primary text-sm">{project?.client?.name}</p>
            <p className="text-text-secondary text-xs">{project?.client?.title}</p>
          </div>
        </div>

        {/* Action Button */}
        <Button
          variant="outline"
          size="sm"
          fullWidth
          iconName="Eye"
          iconPosition="left"
          className="border-primary text-primary hover:bg-primary hover:text-primary-foreground"
        >
          Ver Detalhes do Projeto
        </Button>
      </div>
    </div>
  );
};

export default ProjectCard;